export default __webpack_public_path__ + "static/CaleyJack-4c6cd4e121330baebf48766ebc3992d1.png";